/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Group_Admin_Disabled_HintInputs */

const en_users_form_group_admin_disabled_hint = /** @type {(inputs: Users_Form_Group_Admin_Disabled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Managed in the AWS Console — cannot be assigned from this page.`)
};

const pt_br2_users_form_group_admin_disabled_hint = /** @type {(inputs: Users_Form_Group_Admin_Disabled_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerenciado no Console da AWS — não pode ser atribuído por esta página.`)
};

/**
* | output |
* | --- |
* | "Managed in the AWS Console — cannot be assigned from this page." |
*
* @param {Users_Form_Group_Admin_Disabled_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_group_admin_disabled_hint = /** @type {((inputs?: Users_Form_Group_Admin_Disabled_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Group_Admin_Disabled_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_group_admin_disabled_hint(inputs)
	return pt_br2_users_form_group_admin_disabled_hint(inputs)
});